import { Navigate, useLocation } from "react-router-dom";
import { getStoredUser } from "../api/apiService";

/** Redirects to /login when there's no signed-in user, remembering where they were headed. */
function RequireAuth({ children }) {
  const location = useLocation();
  
  // Use getStoredUser() since tokens aren't always issued (matching your comment)
  const isAuthed = Boolean(getStoredUser());

  if (!isAuthed) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return children;
}

export default RequireAuth;